import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { COMPANY, BRANCHES as STATIC_BRANCHES } from "./data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SettingsCtx = createContext({
  logoUrl: COMPANY.logoUrl,
  branches: STATIC_BRANCHES,
  refresh: () => {},
});

export const SettingsProvider = ({ children }) => {
  const [logoUrl, setLogoUrl] = useState(COMPANY.logoUrl);
  const [branches, setBranches] = useState(STATIC_BRANCHES);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/settings`);
      if (res.data?.logo_url) setLogoUrl(res.data.logo_url);
      if (Array.isArray(res.data?.branches) && res.data.branches.length) {
        // Merge server coords into static metadata (address/phone/email/mapsQuery)
        const merged = STATIC_BRANCHES.map((b) => {
          const srv = res.data.branches.find((x) => x.name === b.name);
          return srv ? { ...b, coords: [srv.lat, srv.lng] } : b;
        });
        setBranches(merged);
      }
    } catch (err) {
      // Non-fatal: log so the issue is debuggable, fall back to defaults.
      console.warn("[settings] /api/settings fetch failed — using defaults:", err);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SettingsCtx.Provider value={{ logoUrl, branches, refresh }}>
      {children}
    </SettingsCtx.Provider>
  );
};

export const useSettings = () => useContext(SettingsCtx);
